import React from 'react'
import reportStyles from './PDFReportStyles';    
import { pdf, Document, Text, Page, View, Image } from '@react-pdf/renderer'

const SocialPage = (params) => {
   
  const entity = params.entity;
  const reportParams = params.params;  

  return (

<Page size="A4" style={reportStyles.page}>
    <View style={reportStyles.HeaderContainer}>
        <Image src={process.env.PUBLIC_URL + '/images/SocialHeader.jpg'}  style={reportStyles.headerImage}/>                                                 
        <Text style={reportStyles.PageTitle}>Social Envirnoment</Text>                    
    </View>                            
    <View style={reportStyles.CenterContainerStart}>    
        <View style={reportStyles.table}>
            <View style={reportStyles.rowPageSubHeaderNBG}>
                <View style={reportStyles.cell50}>
                    <Text style={reportStyles.PageText}>Home Envirnoment</Text>
                    <Text style={reportStyles.description}>Favourability Ratio:</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/RedGreenEQDonut.png'} style={reportStyles.image186Cell}/> 
                </View>
                <View style={reportStyles.cell50BB}>
                    <Text style={reportStyles.PageText}>Emotional Challenge</Text>
                    <Text style={reportStyles.description}>Favourability Ratio:</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/RedMoreGreenDonut.png'} style={reportStyles.image186Cell}/> 
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell50BB}>
                    <Image src={process.env.PUBLIC_URL + '/images/RedBox.png'} style={reportStyles.image22Cell}/> 
                    <Text style={reportStyles.description}>Unfavorable</Text>
                </View>
                <View style={reportStyles.cell50BB}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenBox.png'} style={reportStyles.image22Cell}/> 
                    <Text style={reportStyles.description}>Favorable</Text>
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell50}>
                    <Text style={reportStyles.PageText}>Parent Emotion</Text>
                    <Text style={reportStyles.description}>Favourability Ratio:</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/RedGreen80Donut.png'} style={reportStyles.image186Cell}/> 
                </View>
                <View style={reportStyles.cell50BB}>
                    <Text style={reportStyles.PageText}>Need for consultation</Text>
                    <Text style={reportStyles.PageText}>Recommended*</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenCheck.png'} style={reportStyles.image33Cell}/> 
                    <Text style={reportStyles.description}>Factor score leading to the consultation need*</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenLowInd.png'} style={reportStyles.imageIndCenterCell}/> 
                </View>
            </View>
        </View>                                   
       </View>                            
    <View style={reportStyles.FooterContainerSmall}>
        <Text style={reportStyles.footer}>*Indicates if it is apparent that a consultation with a Child Nutritionist within a short period of time
            could be useful in improving the physical wellbeing of the child. This is calculated based on the
            answers received in the scan and peer comparisons.

            Factor score indicates the number of factors that have contributed to the recommendation of a consultation.

            # Please note that these findings are for informational and educational purposes only. If you feel that
            there might be something wrong with your child's health, please consult a pediatrician immediately.
        </Text>
    </View>                            
    </Page>                      


  )          
}
  
export default SocialPage